export default "__VITE_ASSET__CxP8sZWs__"